import React from "react";
import clsx from "clsx";
import ResponsiveDrawer from "../../components/commons/Drawer";
import useStyles from "../../styles/commonLayoutStyle";

const CommonLayout = props => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {props.showToolBar !== false && <ResponsiveDrawer />}
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: props.showToolBar === false
        })}
      >
        {props.children}
      </main>
    </div>
  );
};

export default CommonLayout;
